import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ProductCard = ({ 
  id, 
  title, 
  description, 
  imageSrc, 
  features, 
  delay = 0 
}) => {
  return (
    <motion.div
      id={id}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true, margin: "-100px" }}
      className="glass-card overflow-hidden group"
    >
      <div className="md:flex">
        <div className="md:w-2/5 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-500/20 to-secondary-500/20 opacity-0 group-hover:opacity-70 transition-opacity duration-500 z-10"></div>
          <motion.img 
            src={imageSrc} 
            alt={title} 
            className="h-64 md:h-full w-full object-cover transition-transform duration-700"
            whileHover={{ scale: 1.05 }}
          />
        </div>
        <div className="p-6 md:p-8 md:w-3/5">
          <h3 className="text-2xl font-bold mb-3 text-white">{title}</h3>
          <p className="text-gray-400 mb-6">{description}</p>
          
          <h4 className="font-semibold text-gray-200 mb-3">Caractéristiques principales:</h4>
          <ul className="space-y-2 mb-6">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <span className="inline-block w-2 h-2 bg-secondary-500 rounded-full mt-2 mr-2 drop-shadow-[0_0_5px_rgba(228,90,255,0.7)]"></span>
                <span className="text-gray-400">{feature}</span>
              </li>
            ))}
          </ul>
          
          <Link 
            to="/contact" 
            className="inline-flex items-center text-primary-500 font-medium hover:text-primary-400 transition-colors"
          >
            Demander une démo <ArrowRight size={16} className="ml-1" />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}

export default ProductCard;
